import { Injectable } from '@angular/core';
import { SharedActionsBaseService } from '@fi-shared/fi-shared-services/shared-actions-base.service';
import { ExtendedSearchService } from '@fi-app/utilities/fi-services/extended-search.service';
import { IOperationOverlayLargeDialogData } from '@fi-app/utilities/operation-overlay-large/operation-overlay-large.service';
import { ObjectTypes } from '@fi-shared/types';
import { UserService } from '@fi-app/user/user.service';
import { BusinessUnitService } from '@fi-app/business-unit/business-unit.service';

@Injectable()
export class FiSharedActionsService extends SharedActionsBaseService {
    constructor(
        private extendedSearchService: ExtendedSearchService,
        private businessUnitService: BusinessUnitService,
        private userService: UserService,
    ) {
        super();
    }

    openUserViewPopup(userId: number) {
        this.userService.openUserViewDialog(userId);
    }

    openUnitViewPopup(unitId: number) {
        this.businessUnitService.openBusinessUnitViewDialog(unitId);
    }

    isExtendedSearchEnabled = true;
    openExtendedSearch(objectType: ObjectTypes, params?: IOperationOverlayLargeDialogData): Promise<any> {
        return this.extendedSearchService.openExtendedSearch(objectType, params);
    }
}
